import React from 'react';

import Icon from './icon';
import LogoSvgFull from '../Header/LogoSvgFull';
import history from '../../history';
import getPlatformUrl from '../../utils/login';

export default class UnderMaintenance extends React.Component {
	clickSignIn = () => {
		history.push('/sign-in');
	};

	// clickLogin = () => {
	// 	history.push('/org-selection');
	// };

	goTo = to => {
		history.push(to);
	};
	handleGoToPlatform = () => {
		const { user } = this.props;

		const redirectUrl = getPlatformUrl({
			organizationSubdomain: user.subdomain_url,
			websiteHost: window.location.host,
		});

		window.location.replace(redirectUrl);
	};

	render() {
		const { styles: s, isLoggedIn, user } = this.props;

		return (
			<div
				style={{
					width: '100vw',
					height: '100vh',
					display: 'flex',
					flexDirection: 'column',
					// background: '#4e4dae',
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						flex: 1,
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<div
						style={{
							display: 'flex',
							width: '400px',
							height: '400px',
							background: 'aliceblue',
							borderRadius: '50%',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<Icon />
					</div>
					<div
						style={{
							display: 'flex',
							// flex: 1,
							marginTop: '50px',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<h4
							style={{
								fontSize: '40px',
								fontWeight: '800',
								color: '#b1c0ca',
								lineHeight: '60px',
								textAlign: 'center',
							}}
						>
							We are currently under maintenance.
						</h4>
						<p
							style={{
								fontSize: '22px',
								color: '#b1c0ca',
								textAlign: 'center',
							}}
						>
							We will be back and up soon.
						</p>
						<p
							style={{
								fontSize: '22px',
								color: '#4e4dae',
								textAlign: 'center',
							}}
						>
							Our platform is still running.
						</p>
					</div>
				</div>
				<div className={s.buttons}>
					{!isLoggedIn && <button onClick={this.clickSignIn}>Login</button>}
					{/* {!isLoggedIn && <button onClick={this.clickLogin}>Sign In</button>} */}
					{isLoggedIn && user && user.subdomain_url && (
						<button onClick={this.handleGoToPlatform}>Go to Platform</button>
					)}
					{isLoggedIn && (
						<button onClick={() => this.goTo('/logout')}>
							<i className="fa fa-power-off" style={{ marginRight: '10px' }} />
							Logout
						</button>
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Layout/UnderMaintenance.js